import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { IoArrowBack } from "react-icons/io";
import { MdOutlineArrowBack } from "react-icons/md";
import axios from "axios";
import * as XLSX from "xlsx";
import moment from "moment";
import { useSelector } from "react-redux";
import GroupReportCard from "./GroupReportCard";
import AvgTimePerPerson from "./AvgTimePerPerson";
import RelationalDataSummary from "./RelationalDataSummary";
import PredictiveDataSummery from "../PredictiveDataSummery";
import Error from "./Error";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Languages from "./Languages";
import { BackIcon, SpinnerIcon } from "../../../../../assets/icons/iconshere";
import { FaArrowLeftLong } from "react-icons/fa6";
import NoAnalyticReportFound from "../../../NoData/NoAnalyticReportFound";
import { exportMultipleChartsToPdf, generateExcel } from "../../../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../../../SvgIconsData";
import LargeATPChart from "./ChartModals/LargeATPChart";
import LargeRDSChart from "./ChartModals/LargeRDSChart";
import LargeErrorChart from "./ChartModals/LargeErrorChart";

const GroupReport = ({ returnToGroup, module, group }) => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [aptEnlarge, setAPTEnlarge] = useState(false);
  const [rdsEnlarge, setRDSEnlarge] = useState(false);
  const [errorEnlarge, setErrorEnlarge] = useState(false);
  const [loading, setLoading] = useState(true)
  const [pdfSpinner, setPdfSpinner] = useState(false);
  const [excelSpinner, setExcelSpinner] = useState(false);
  const [analytics, setAnalytics] = useState({
    quizScore:{
      total: 0,
      max: 0,
      avg: 0
    },
    totalCounts: {
      all: 0,
      guided: 0,
      unguided: 0,
    },
    userBreakdown: {
      total: 0,
      active: 0,
      inactive: 0,
    },
    languageCounts: [],
    errors: {
      all: 0,
      guided: 0,
      unguided: 0,
    },
    errorsPerUser: 0,
    duration: {
      all: {
        average: {
          inSeconds: 0,
          humanReadable: null,
        },
      },
      guided: {
        average: {
          inSeconds: 0,
          humanReadable: null,
        },
      },
      unguided: {
        average: {
          inSeconds: 0,
          humanReadable: null,
        },
      },
    },
    maxErrorProneTask: null,
    maxTimeTakingTask: null,
    userCharts: [],
    errorSpider: [],
  });

  const getGroupReportAnalytics = async () => {
    try {
      let { data } = await axios.get(`${configData.config.API_URL}/api/analytics/group/module/${group.uuid}/${module.uuid}`,{
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          }});

      let languageCounts = data.languageCounts.filter(e => e.key !=="NA" && e.key !== null );
      setAnalytics({ ...data,languageCounts:languageCounts });
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(true)
    }
  };

  useEffect(() => {
    getGroupReportAnalytics();
  }, [module, group]);

  const tableData1 = [
    ["Course Wise Report", ""],
    ["Group Name", group.name ?? ""],
    ["Course Name", module.name ?? ""],
    ["Times Played - Total", analytics.totalCounts.all],
    ["Times Played - Guided", analytics.totalCounts.guided],
    ["Times Played - Unguided", analytics.totalCounts.unguided],
    ["Users - Total", analytics.userBreakdown.total],
    ["Users - Active", analytics.userBreakdown.active],
    ["Users - Inactive", analytics.userBreakdown.inactive],
    ["Average Errors Per Iteration", analytics.errors.unguided || 0],
    ["Average Errors Per User", analytics.errorsPerUser || 0],
  ];

  const tableData2 = [
    ["Predictive Data Summary", ""],
    ["Task with maximum time taken", analytics?.maxTimeTakingTask],
    [" Task with maximum error", analytics?.maxErrorProneTask],
  ];


  const handleClickPdfDownload = async(name, table1, table2) => {
    setPdfSpinner(true);
    await exportMultipleChartsToPdf(name, table1, table2)
    setPdfSpinner(false);
  }

  const handleClickExcelDownload = async(name, table1, table2) => {
    setExcelSpinner(true);
    await generateExcel(name, table1, table2)
    setTimeout(()=>setExcelSpinner(false),500)
  }


  return (
    <>
      <div className="container-fluid p-3 grpreportpage">
        <div className="row mt-1 justify-content-between mb-3">
          <div className="col-8 col-md-6">
            <div className="d-flex align-items-center">
              <span
                className="backbtn cursor-pointer me-2"
                title="Back"
                style={{ fontSize: "20px" }}
                onClick={returnToGroup}>
                {" "}
                <FaArrowLeftLong />{" "}
              </span>
              <div className="moudlendgroup">
                <img src={`${module.versions[0].data.thumbnail}`} />
                <div className="data">
                  <h5>{module.name ?? ""}</h5>
                  <p>{group.name ?? ""}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 col-md-6 d-flex gap-2 align-items-center justify-content-end">
           { !loading &&
           <>
           <button
              className="DefaultRedBtn download px-2"
              title="Download PDF"
              onClick={() => handleClickPdfDownload("User_Dashboard", tableData1, tableData2)}>
              {pdfSpinner ? <SpinnerIcon /> : <PDFDownloadIcon />}
            </button>
            <button
              className="DefaultRedBtn download px-2"
              title="Download Excel"
              onClick={() => handleClickExcelDownload("User_Dashboard", tableData1, tableData2)}>
              {excelSpinner ? <SpinnerIcon /> : <EXLDownloadIcon />}
            </button>
            </>
            } 
          </div>
        </div>
        <div className="row">
          <div className="report_stats">
          <GroupReportCard group={group} module={module} loading={loading} analytics={analytics} />
          </div>
        </div>
        <div className="row admincharts mt-1">
          { loading ? 

          <>
            <div className="col-md-9">
                <div className="row">
                  <div className="col-md-6 custom-chart">
                  <div className="cardbox overflow-hidden">
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <h5 className="mb-1 pb-0 "> <Skeleton width="5vw"/> </h5>
                    <p className="text_enlarge_option mb-1 ">
                      <Skeleton width="5vw"/>
                    </p>
                  </div>
                  <div className='chartlegends'>
                    <p><Skeleton width="5vw"/></p>
                    <p><Skeleton width="5vw"/> </p>
                  </div>
                  <div id="chart">
                      <Skeleton width="100%" height="22.5rem"/>
                  </div>
              </div>
                  </div>
                  <div className="col-md-6 custom-chart ps-0">
                  <div className="cardbox overflow-hidden">
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <h5 className="mb-1 pb-0 "> <Skeleton width="5vw"/> </h5>
                    <p className="text_enlarge_option mb-1 ">
                      <Skeleton width="5vw"/>
                    </p>
                  </div>
                
                  <div id="chart">
                      <Skeleton width="100%" height="24.2rem"/>
                  </div>
              </div>
                  </div>
                </div>
                </div>
                <div className="col-md-3 ps-0">
                
                  <div className="cardbox overflow-hidden">
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <h5 className="mb-1 pb-0 "> <Skeleton width="5vw"/> </h5>
                    <p className="text_enlarge_option mb-1 ">
                      <Skeleton width="5vw"/>
                    </p>
                  </div>
                
                  <div id="chart">
                      <Skeleton width="100%" height="24.2rem"/>
                  </div>
              </div>
                 
                </div>
          </>
          :
          <>
          
          {analytics.totalCounts.all > 0 ? (
            <>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-6 custom-chart">
                    <AvgTimePerPerson analytics={analytics} setAPTEnlarge={setAPTEnlarge}/>
                  </div>
                  <div className="col-md-6 custom-chart ps-0">
                    <Error errorSpider={analytics.errorSpider} setErrorEnlarge={setErrorEnlarge}/>
                    {/* <RelationalDataSummary userCharts={analytics.userCharts} /> */}
                  </div>
                </div>
                </div>
                <div className="col-md-3 ps-0">
                  <RelationalDataSummary userCharts={analytics.userCharts} setRDSEnlarge={setRDSEnlarge} />
                </div>
                
                  <div className= {analytics?.languageCounts.length > 0 ? "col-md-9 h-100 mt-2" : "col-md-12 h-100 mt-2" } >
                  <div className="row h-100">
                  <div className="col-md-12 h-100 custom-chart">
                    <PredictiveDataSummery group={true} analytics={analytics} />
                  </div>
                  </div>
                  </div>
                  {analytics?.languageCounts.length > 0  &&
                  <div className="col-md-3 mt-2 h-100 ps-0">
                      <Languages language={analytics?.languageCounts || []} />
                  </div>
                  }
               
              
            </>
          ) : (
            <NoAnalyticReportFound />
          )}

          </>}
        </div>
      </div>

        {aptEnlarge && <LargeATPChart analytics={analytics} aptEnlarge={aptEnlarge} setAPTEnlarge={setAPTEnlarge}/> }
        {rdsEnlarge && <LargeRDSChart userCharts={analytics.userCharts} rdsEnlarge={rdsEnlarge} setRDSEnlarge={setRDSEnlarge} /> }
        {errorEnlarge && <LargeErrorChart errorSpider={analytics.errorSpider} errorEnlarge={errorEnlarge} setErrorEnlarge={setErrorEnlarge} /> }
    </>
  );
};

export default GroupReport;
